import { SORT_BY_OPTIONS_MAPPING } from "@/constants/filter";
import { productAxiosInstance } from "@/services/axios";
import { getParams } from "@/utils/product/listing";

export const getProductListing = async ({
  searchParams,
  page,
  hasThemeCake = false,
  menuId,
}: {
  searchParams: Record<string, string | string[] | undefined>;
  page: number;
  menuId?: string;
  hasThemeCake?: boolean;
}) => {
  const { id, sort_by, is_navbar_label, category_id, is_theme_cake, ...rest } =
    getParams(searchParams);

  const cleanId = category_id || (Array.isArray(id) ? id[0] : id);
  const isNavLabel = is_navbar_label || !!category_id;

  const ALLOWED_FILTER_KEYS = [
    "base_price_amount__gte",
    "base_price_amount__lte",
    "vendor_id",
    "vendor",
    "is_best_product",
    "name__icontains",
    "tag_ids",
    "themeCake",
    "themeCake__in",
    "category_id",
  ];

  const filterPayload = ALLOWED_FILTER_KEYS.reduce((acc: Record<string, unknown>, key) => {
    if (rest[key] !== undefined) acc[key] = rest[key];
    return acc;
  }, {});

  if (!rest.vendor_id && !rest.vendor) {
    filterPayload.is_theme_cake = hasThemeCake;
  }

  const params = {
    filter_by: JSON.stringify(filterPayload),
    page,
    ...(id
      ? {
          collection_ids: Array.isArray(id) ? id.join(",") : id,
        }
      : isNavLabel && cleanId
        ? { parent_nav_collection_id: cleanId }
        : {}),
    send_theme_cakes: hasThemeCake || is_theme_cake === true,
    ...(menuId ? { menu_id: menuId } : {}),
    sort_by:
      SORT_BY_OPTIONS_MAPPING[sort_by as keyof typeof SORT_BY_OPTIONS_MAPPING]
        ?.value,
  };
  const response = await productAxiosInstance.get("/products/list_public/", {
    params,
  });
  return response.data;
};
